require('./optionGroupCheckbox.i18n.json');
require('./optionGroupCheckbox.tpl.html');
require('./optionGroupCheckboxController.js');

const OptionGroupCheckboxComponent = {
    templateUrl: '/configuration/formEditor/content/form/componentSettings/optionGroup/optionGroupCheckbox/optionGroupCheckbox.tpl.html',
    controller: 'optionGroupCheckboxController',
    bindings: {
        selectedField: '<',
        name: '<',
        label: '<',
        value: '<',
        isDisabled: '<'
    }
};

angular.module('ums.configuration')
    .component('uiOptionGroupCheckbox', OptionGroupCheckboxComponent);
